exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index__banner___3ckgq {\n  width: 100%;\n  height: 144px;\n  line-height: 144px;\n  background: #232526;\n}\n@media (max-width: 1024px) {\n  .index__banner___3ckgq {\n    margin-top: 50px;\n  }\n}\n.index__banner___3ckgq .index__title___3nYSn {\n  margin: 0 auto;\n  font-size: 32px;\n  line-height: 144px;\n  color: #fff;\n}\n@media (max-width: 1200px) {\n  .index__banner___3ckgq .index__title___3nYSn {\n    margin-left: 24px;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"banner": "index__banner___3ckgq",
	"title": "index__title___3nYSn"
};